<template>
  <div>
    <div class="chat-preview">
      <v-badge
        v-if="bindedUserData.newMatchId === chatId"
        color="green"
        class="chat-badge"
      >
        <template v-slot:badge>
          <v-icon color="white">sports_soccer</v-icon>
        </template>
        <div
          @click="emitOpenProfile"
          :class="[
            'chat-preview__image-wrapper',
            isBlocked ? 'chat-preview__disabled' : '',
          ]"
        >
          <div
            class="chat-preview__avatar chat-preview__avatar-shadow"
            :class="{ 'chat-preview__avatar-online': isContactIdOnline }"
            :style="{ backgroundImage: 'url(' + picture + ')' }"
          ></div>
        </div>
      </v-badge>
      <v-badge v-else-if="newMessages" color="red" class="chat-badge">
        <template v-slot:badge>
          <span>1</span>
        </template>
        <div
          @click="emitOpenProfile"
          :class="[
            'chat-preview__image-wrapper',
            isBlocked ? 'chat-preview__disabled' : '',
          ]"
        >
          <div
            class="chat-preview__avatar chat-preview__avatar-shadow"
            :class="{ 'chat-preview__avatar-online': isContactIdOnline }"
            :style="{ backgroundImage: 'url(' + picture + ')' }"
          ></div>
        </div>
      </v-badge>
      <div
        v-else
        :class="[
          'chat-preview__image-wrapper',
          isBlocked ? 'chat-preview__disabled' : '',
        ]"
      >
        <div
          @click="emitOpenProfile"
          class="chat-preview__avatar chat-preview__avatar-shadow"
          :class="{ 'chat-preview__avatar-online': isContactIdOnline }"
          :style="{ backgroundImage: 'url(' + picture + ')' }"
        ></div>
      </div>
      <div class="chat-preview__data" @click="emitOpenChat">
        <div>
          <v-chip small v-if="isBlocked">
            <small style="color: white">inaktiv</small>
          </v-chip>
          <span :class="['d-block', isBlocked ? 'chat-preview__disabled' : '']">
            <b>{{ name }}</b>
          </span>
          <span
            :class="['d-block', isBlocked ? 'chat-preview__disabled' : '']"
            style="font-size: 13px"
          >
            {{ shortMsg }}
          </span>
        </div>
        <div class="actions">
          <v-btn
            v-if="!isBlocked"
            @click.stop="deactivateChatDialog = true"
            class="connect-question-remove"
            flat
            icon
            color="red"
          >
            <v-icon>mdi-chat-remove</v-icon>
          </v-btn>
          <!-- <v-btn v-if="isBlockedByMe" @click.stop="reactivateChatDialog = true" class="connect-question-remove" flat icon color="grey">
            <v-icon>mdi-reload</v-icon>
          </v-btn> -->
        </div>
      </div>
    </div>

    <v-dialog v-model="deactivateChatDialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline">Chat deaktivieren</v-card-title>

        <v-card-text class="text-xs-left">
          Möchtest du den Chat wirklich deaktivieren?
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="deactivateChatDialog = false">Abbrechen</v-btn>
          <v-btn :loading="loading" color="red white--text" text @click="deactivateChat"
            >Ja</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reactivateChatDialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline">Chat aktivieren</v-card-title>

        <v-card-text class="text-xs-left">
          Möchtest du den Chat aktivieren?
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="reactivateChatDialog = false">Abbrechen</v-btn>
          <v-btn :loading="loading" color="red white--text" text @click="reactivateChat"
            >Ja</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import firebase from 'firebase';
import { db } from '@/db';

export default {
  name: 'chat-preview',

  props: ['name', 'picture', 'msg', 'chatId', 'lastMessageDetails', 'inactiveInfo'],

  data() {
    return {
      deactivateChatDialog: false,
      reactivateChatDialog: false,
      loading: false,
    };
  },

  computed: {
    ...mapState(['bindedUserData', 'user_data', 'userMatches', 'onlineChatUsers']),

    shortMsg() {
      let shortMsg = this.msg;
      if (shortMsg && shortMsg.length > 40) {
        shortMsg = `${shortMsg.slice(0, 40)}...`;
      }
      return shortMsg;
    },

    newMessages() {
      if (
        !this.lastMessageDetails ||
        this.lastMessageDetails.creatorId === this.bindedUserData.id
      ) {
        return false;
      }

      // don't show new message bubble if chat was blocked by sender
      if (
        !this.lastMessageDetails.recieverRead
        // && (!this.inactiveInfo || !this.inactiveInfo.status
        // || (this.inactiveInfo
        //   && this.inactiveInfo.status
        //   && this.inactiveInfo.blockedBy === this.user_data.id))) {
      ) {
        return true;
      }

      return false;
    },

    contactId() {
      return this.chatId.replace(this.user_data.id, '');
    },

    isContactIdOnline() {
      return this.onlineChatUsers.includes(this.contactId);
    },

    isBlockedByMe() {
      return (
        this.inactiveInfo &&
        this.inactiveInfo.status &&
        this.inactiveInfo.disabledBy.includes(this.user_data.id)
      );
    },

    isBlocked() {
      return false;
      // return this.inactiveInfo && this.inactiveInfo.status;
    },
  },

  methods: {
    emitOpenChat() {
      // if (!this.isBlocked || this.isBlockedByMe) {
      this.$emit('click');
      // }
    },

    emitOpenProfile() {
      this.$emit('open-profile');
    },

    async deactivateChat() {
      const inactive = this.inactiveInfo ? this.inactiveInfo : [];
      const disabledBy = [...inactive, this.user_data.id];

      this.loading = true;

      await db.collection('matches').doc(this.chatId).update({
        disabledBy,
      });

      const userMatchUpdated = this.userMatches.find((m) => m.chat_id === this.chatId);
      this.$set(userMatchUpdated, 'disabledBy', disabledBy);

      this.loading = false;
      this.deactivateChatDialog = false;
    },

    async reactivateChat() {
      const inactive = {
        status: false,
        disabledBy: this.user_data.id,
      };

      this.loading = true;

      await db.collection('matches').doc(this.chatId).update({
        inactive,
      });

      const userMatchUpdated = this.userMatches.find((m) => m.chat_id === this.chatId);
      this.$set(userMatchUpdated, 'inactive', inactive);

      this.loading = false;
      this.reactivateChatDialog = false;
    },
  },

  created() {
    const contactStatus = firebase
      .database()
      .ref(`user_status/${this.contactId}/connected`);

    // Attach an asynchronous callback to read the data if user is online
    contactStatus.on(
      'value',
      (snapshot) => {
        const status = snapshot.val();

        if (status) {
          this.$store.commit('addOnlineChatUser', this.contactId);
        } else {
          this.$store.commit('removeOnlineChatUser', this.contactId);
        }
      },
      (errorObject) => {
        console.log(`Status check failed: ${errorObject.code}`);
      },
    );
  },
};
</script>

<style scoped>
.v-badge__badge .v-icon {
  font-size: 18px;
}
</style>
